import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective } from 'ngx-mask';
import Swal from 'sweetalert2';
import { RestClientService } from '../../../../core/service/rest-client.service';
import { AuthService } from '../../../../core/service/auth.service';
import { UtilitiesService } from '../../../../core/service/utilities.service';
import { BenefInfoComponent } from '@shared/components/benef-info/benef-info.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OWL_DATE_TIME_LOCALE, OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { FileUploadComponent } from '@shared/components/file-upload/file-upload.component';
import { IntegerFormatPipe } from "../../../../shared/pipe/integer-format.pipe";
import { SearchFormComponent } from "@shared/components/search-form/search-form.component";
import { FormPresHospitComponent } from '../liste-demande-hospit-active/form-exploitation-hospit/form-pres-hospit/form-pres-hospit.component';
import { FormExecHospitComponent } from '../liste-demande-hospit-active/form-exploitation-hospit/form-exec-hospit/form-exec-hospit.component';

@Component({
  selector: 'app-demande-hospitalisation',
imports: [CommonModule, NgSelectModule, FormsModule, BenefInfoComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    FileUploadComponent,
    CommonModule,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatButtonModule,
    NgxMaskDirective,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatSlideToggleModule, IntegerFormatPipe, SearchFormComponent, FormPresHospitComponent, FormExecHospitComponent],
  templateUrl: './demande-hospitalisation.component.html',
  styleUrl: './demande-hospitalisation.component.scss',
  providers: [{ provide: OWL_DATE_TIME_LOCALE, useValue: 'fr-FR' }]
})
export class DemandeHospitalisationComponent {
 selectedTab = 'tab1';
  @Output() onSendBenefItem = new EventEmitter<any>();
  @Output() onSendConsultationStatut = new EventEmitter<any>();
  @Output() onCloseConsultationModal = new EventEmitter<any>();
  @Output() onGoToTab = new EventEmitter<any>();
  @Input() matricule: any
  @Input() itemBeneficiare: any

  isLoading: boolean | undefined;
  input_value: any;
  input_option = 'MAT';
  searchPlaceHolder = 'Entrez numéro matricule'
  user: any = {};
  isProcessComplete = false;
  itemToSave: any = {};
  reloadList:any
  @Input() refreshTriggerConsultation!: boolean;
  medecins = [
    { id: 1, name: 'Dr. John', specialite: 'Cardiologue' },
    { id: 1, name: 'Dr. Méa', specialite: 'Docteur' },
    { id: 1, name: 'Dr. Yves', specialite: 'Dermato' },
  ];
  actes = [
    { id: 1, name: 'Consultation généraliste' },
    { id: 2, name: 'Consultation spécialiste' },
  ];
  itemsPratitien: any;
  itemsTypeHospitalisation: any;
  itemTarifActe: any;
  itemsRaisonConsultation: any = [];
  itemsTypeChambreHospitalisation: any = [];
  fileName1: any;
  currentFile: any;
  itemsGarantie: any = [];
  beneficiaireAutOselect: any;
  latitude: number | null = null;
  longitude: number | null = null;
  itemsRaisonHospitalisation: any;
  itemToAdd: any = {};
  itemsDetailProforma: any = [];
  selectedTypeHospitalisation: any = {};
  constructor(
    private restClient: RestClientService,
    private authService: AuthService,
    private utilities: UtilitiesService
  ) {
    // this.authService.setActiveBeneficiaire({})
    this.user = this.authService.getCurrentUser();
    console.log('connected user: ', this.user);
    this.beneficiaireAutOselect = ""

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          console.log('Captured Lat:', this.latitude, 'Lng:', this.longitude);
          let pos = { latitude: this.latitude, longitude: this.longitude }
          this.authService.setUserPosition(pos)
        },
        (error) => {
          console.error('Error capturing location:', error);
        }
      );
    } else {
      console.error('Geolocation not supported by this browser.');
    }
    this.authService.setActiveBeneficiaire({});
    this.getItemRaisonHospitalisation()
    this.getItemsTypeHospitalisation()
    this.getItemsTypeChambreHospitalisation()
    this.getItemsGarantie()
    this.itemToAdd.quantite = 1
    this.itemToSave.date_entree = new Date();
    this.itemToSave.duree_demande = 1;
  }

    ngOnChanges(changes: SimpleChanges) {
      console.log('changes: ',changes)
    if (changes['itemBeneficiare'] && changes['itemBeneficiare'].currentValue) {
      console.log("changes['itemBeneficiare']: ",changes['itemBeneficiare'])
      this.itemBeneficiare = changes['itemBeneficiare'].currentValue
    
    }
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];

      console.info('fileName', fileName);
      console.info('extension', extension);
      this.fileName1 = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        // this.imageDisplay = data;
        const fileBase64 = data.split(',')[1];
        this.currentFile = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: 'custom type',
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  getItemsTypeHospitalisation() {
    let request = {
      index: 0,
      size: 1000,
      // search_key: 'CONSULT',
      data: {
        // garantie_id:garantie_id
      },
    };

    this.restClient.post('typeHospitalisation/getByCriteria', request).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsTypeHospitalisation = res.items;
          console.log('this.itemsTypeHospitalisation: ', this.itemsTypeHospitalisation);
          const hm = this.itemsTypeHospitalisation.find((t: any) => t.codification === 'HM');
          if (hm) {
            this.itemToSave.type_hospitalisation_id = hm.id;
            this.selectedTypeHospitalisation = hm;
          }
        } else {
          this.utilities.showSweetNotification(res['status']['message'], 'error');
          this.itemsTypeHospitalisation = [];
        }
      },
      error: (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsTypeHospitalisation = [];
      }
    });
  }
  getItemsTypeChambreHospitalisation() {
    let request = {
      index: 0,
      size: 1000,
      // search_key: 'CONSULT',
      data: {
        // garantie_id:garantie_id
      },
    };

    this.restClient.post('typeChambreHospitalisation/getByCriteria', request).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsTypeChambreHospitalisation = res.items;
          console.log('this.itemsTypeChambreHospitalisation: ', this.itemsTypeChambreHospitalisation);
        } else {
          this.utilities.showSweetNotification(res['status']['message'], 'error');
          this.itemsTypeChambreHospitalisation = [];
        }
      },
      error: (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsTypeChambreHospitalisation = [];
      }
    });
  }

  confirmSaveItem() {
    console.log("this.itemToSave: ", this.itemToSave)
    if (!this.itemToSave || !this.itemToSave.type_hospitalisation_id) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner type hospitalisation',
        'error'
      );
      return;
    }
    if (!this.itemToSave || !this.itemToSave.raison_hospitalisation_id) {
      this.utilities.showSweetNotification('Veuillez renseigner raison hospitalisation/mise en observation', 'error');
      return;
    }
    if(this.selectedTypeHospitalisation.codification == 'HM'){
      if (!this.itemToSave || !this.itemToSave.type_chambre_hospitalisation_id) {
          this.utilities.showSweetNotification('Veuillez renseigner type chambre hospitalisation', 'error');
          return;
        }
      if (!this.itemToSave || !this.itemToSave.date_entree) {
          this.utilities.showSweetNotification('Veuillez renseigner date entrée', 'error');
          return;
        }
      if (!this.itemToSave || !this.itemToSave.duree_demande) {
          this.utilities.showSweetNotification('Veuillez renseigner la durée prévisionnelle', 'error');
          return;
        }
    }
    if(this.selectedTypeHospitalisation.codification == 'HC'){
      if (!this.itemToSave || !this.itemToSave.date_intervention) {
          this.utilities.showSweetNotification('Veuillez renseigner date intervention', 'error');
          return;
        }
      if (!this.itemsDetailProforma || !this.itemsDetailProforma.length) {
          this.utilities.showSweetNotification('Veuillez renseigner la facture proforma', 'error');
          return;
        }
          if (!this.itemToSave || !this.itemToSave.duree_demande) {
          this.utilities.showSweetNotification('Veuillez renseigner la durée prévisionnelle', 'error');
          return;
        }
    }
    if(this.selectedTypeHospitalisation.codification == 'MOE'){
      if (!this.itemToSave || !this.itemToSave.heure_debut_observation) {
          this.utilities.showSweetNotification('Veuillez renseigner heure debut observation', 'error');
          return;
        }
      if (!this.itemToSave || !this.itemToSave.heure_fin_observation) {
          this.utilities.showSweetNotification('Veuillez renseigner heure fin observation', 'error');
          return;
        }
    }
 
    Swal.fire({
      title: 'Demande hospitalisation',
      text: 'Souhaitez-vous poursuivre cette action?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.saveItem();
      }
    });
  }





  saveItem() {
    this.isProcessComplete = false;

    this.itemToSave.prestataire_id = this.user.prestataire_id;
    this.itemToSave.beneficiaire_id = this.itemBeneficiare.id;
    this.itemToSave.matricule = this.itemBeneficiare.matricule;
    this.itemToSave.matricule_assure = this.itemBeneficiare.matricule_parent;
    this.itemToSave.is_hospit = true;
    this.itemToSave.is_pending_validate = true;
    this.itemToSave.garantie_id = this.itemsGarantie.find((ig: any) => ig.codification === 'HOS')?.id ?? null;

    if (this.selectedTypeHospitalisation.codification === 'HC') {
      this.itemToSave.datasDetailProformaHospit = this.itemsDetailProforma.map((ddph: any) => ({
        ...ddph,
        prestataire_id: this.user.prestataire_id,
        beneficiaire_id: this.itemBeneficiare.id,
        montant_demande: ddph.total,
      }));
      this.itemToSave.montant_demande = this.getTotal();
    }

    let request: any = {
      datas: [{ ...this.itemToSave }],
    };

    if (this.currentFile && Object.keys(this.currentFile).length) {
      request.file_data = this.currentFile;
    }

    request.datas.forEach((d: any) => { d.prestataire_id = this.user.prestataire_id; });

    this.restClient.post('prescriptionActe/create', request).subscribe({
      next: (res: any) => {
        if (res && !res['hasError']) {
          this.isProcessComplete = true;
          this.utilities.showSweetNotification(res['status']['message'], 'succes');
          this.itemToSave = {};
          this.itemsDetailProforma = [];
          this.reloadList = Math.random();
          this.onCloseConsultationModal.emit();
        } else {
          this.isProcessComplete = false;
          this.utilities.showSweetNotification(res['status']['message'], 'error');
        }
      },
      error: (error) => {
        this.isProcessComplete = false;
        this.utilities.showSweetNotification(error, 'error');
      }
    });
  }


  getItemRaisonHospitalisation() {
    let request = {
      index: 0,
      size: 1000,
      order_by: '-libelle',
      data: {},
    };

    this.restClient
      .post('raisonHospitalisation/getByCriteria', request)
      .subscribe({
        next: (res: any) => {
          this.isLoading = false;
          if (res && !res['hasError'] && res['items']) {
            this.itemsRaisonHospitalisation = res.items;
            console.log('this.itemsRaisonHospitalisation: ', this.itemsRaisonHospitalisation);
            this.itemToSave.raison_consultation_id = this.itemsRaisonHospitalisation[0].id;
          } else {
            this.utilities.showSweetNotification(res['status']['message'], 'error');
            this.itemsRaisonHospitalisation = [];
          }
        },
        error: (error) => {
          this.utilities.showSweetNotification(error, 'error');
          this.itemsRaisonHospitalisation = [];
        }
      });
  }

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }

  resetForm() {
    this.itemToSave = {
      date_entree: new Date(),
      duree_demande: 1,
    };
    this.itemsDetailProforma = [];
    this.currentFile = null;
    this.fileName1 = null;
    this.isProcessComplete = false;
    const hm = this.itemsTypeHospitalisation?.find((t: any) => t.codification === 'HM');
    if (hm) {
      this.itemToSave.type_hospitalisation_id = hm.id;
      this.selectedTypeHospitalisation = hm;
    } else {
      this.selectedTypeHospitalisation = {};
    }
  }

  onSelectTypeHospitalisation() {
    this.selectedTypeHospitalisation = this.itemsTypeHospitalisation.find((ith: any) => ith.id == this.itemToSave.type_hospitalisation_id)

  }
  onSelectRaisonHospitalisation() {

  }
  onSelectTypeChambreHospitalisation() {

  }


  onAddItemToList(): void {

    if (!this.itemToAdd || !this.itemToAdd.libelle) {
      this.utilities.showSweetNotification(
        "Veuillez renseigner libellé",
        'error'
      );
      return;
    }
    if (!this.itemToAdd || !this.itemToAdd.quantite) {
      this.utilities.showSweetNotification(
        "Veuillez renseigner quantité",
        'error'
      );
      return;
    }
    if (!this.itemToAdd || !this.itemToAdd.prix_unitaire) {
      this.utilities.showSweetNotification(
        "Veuillez renseigner prix unitaire",
        'error'
      );
      return;
    }


  
    console.log('obj: ', this.itemToAdd)
    this.itemToAdd.total = this.itemToAdd.quantite * this.itemToAdd.prix_unitaire
    let obj = { ...this.itemToAdd }

    this.itemsDetailProforma.unshift({ ...obj })
    this.itemToAdd = {}
    this.itemToAdd.quantite = 1

  }

  getItemsGarantie() {
    this.restClient.post('garantie/getByCriteria', { index: 0, size: 1000, data: {} }).subscribe({
      next: (res: any) => {
        if (res && !res['hasError'] && res['items']) {
          this.itemsGarantie = res.items;
        }
      },
      error: () => { this.itemsGarantie = []; }
    });
  }

  getTotal() {
    let total = 0
    if (this.itemsDetailProforma && this.itemsDetailProforma.length) {
      this.itemsDetailProforma.map((it: any) => {
        total += it.total
      })
    }
    return total
  }
}
